(function () {
  'use strict';

  var MAX_BAGS = 6;
  var CAP_WEIGHTS_GRAMS = [12000, 12500, 16000];
  var excludedProductIds = new Set();

  var modal = null;
  var countEl = null;
  var allowCheckout = false;

  function loadExcludedProductIds() {
    var el = document.getElementById('CartBagCapExcludedProductIds');
    if (!el) return;

    try {
      JSON.parse(el.textContent).forEach(function (id) {
        excludedProductIds.add(Number(id));
      });
    } catch (error) {
      excludedProductIds = new Set();
    }
  }

  function isExcludedProduct(item) {
    if (!item || item.product_id == null) return false;

    if (excludedProductIds.has(Number(item.product_id))) return true;

    return !!document.querySelector(
      '[data-bag-cap-excluded="true"][data-product-id="' + item.product_id + '"]'
    );
  }

  function isCapWeight(grams) {
    return CAP_WEIGHTS_GRAMS.indexOf(Number(grams)) !== -1;
  }

  function isCapBagProduct(item) {
    if (isExcludedProduct(item)) return false;
    if (isCapWeight(item.grams)) return true;

    if (item.product_id && document.querySelector('[data-bag-cap-qualified="true"][data-product-id="' + item.product_id + '"]')) {
      return true;
    }

    return false;
  }

  function countCapBags(items) {
    var total = 0;

    (items || []).forEach(function (item) {
      if (!isCapBagProduct(item)) return;
      total += Number(item.quantity) || 0;
    });

    return total;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function openModal(bagCount) {
    if (!modal) return;

    if (countEl) {
      countEl.textContent = 'Your cart currently has ' + bagCount + ' qualifying bags (maximum ' + MAX_BAGS + ' online).';
      countEl.hidden = false;
    }

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }

    modal.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    if (!modal) return;

    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }

    modal.setAttribute('aria-hidden', 'true');
  }

  function validateCheckout() {
    return fetchCart().then(function (cart) {
      var bagCount = countCapBags(cart.items);
      return {
        allowed: bagCount <= MAX_BAGS,
        bagCount: bagCount,
      };
    });
  }

  function proceedCheckout(form, submitter) {
    allowCheckout = true;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter || undefined);
    } else {
      form.submit();
    }

    allowCheckout = false;
  }

  function onCheckoutAttempt(event, form, submitter) {
    if (allowCheckout) return;

    event.preventDefault();
    event.stopPropagation();

    validateCheckout()
      .then(function (result) {
        if (result.allowed) {
          proceedCheckout(form, submitter);
          return;
        }

        openModal(result.bagCount);
      })
      .catch(function () {
        proceedCheckout(form, submitter);
      });
  }

  function bindEvents() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;

        if (!form || !form.matches('[data-cart-form]')) return;

        var submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;

        onCheckoutAttempt(event, form, submitter);
      },
      true
    );

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-bag-cap-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.open) {
        closeModal();
      }
    });

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
    }
  }

  function init() {
    modal = document.querySelector('[data-cart-bag-cap-modal]');
    countEl = document.querySelector('[data-cart-bag-cap-count]');
    loadExcludedProductIds();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
